import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import LymanCarouselComps from "./LymanCarouselComps";
import CentralDoctraineAndOtherCommonFooterBlock from "../../../components/CentralDoctraineAndOtherCommonFooterBlock/CentralDoctraineAndOtherCommonFooterBlock";

import LaymanPage1 from "./LaymanPage1";
import LaymanPage2 from "./LaymanPage2";
import LaymanPage3 from "./LaymanPage3";
import LaymanPage4 from "./LaymanPage4";
import LaymanPage5 from "./LaymanPage5";
import LaymanPage6 from "./LaymanPage6";
import LaymanPage7 from "./LaymanPage7";
import LaymanPage8 from "./LaymanPage8";
import LaymanPage9 from "./LaymanPage9";
import LaymanPage9_helios_part from "./LaymanPage9_helios_part";
import LaymanPage9_protogonos_part from "./LaymanPage9_protogonos_part";
import LaymanPage9_sacred_divine from "./LaymanPage9_sacred_divine";
import LaymanPage10 from "./LaymanPage10";
import LaymanPage10_kalikrishna from "./LaymanPage10_kalikrishna";
import LaymanPage11 from "./LaymanPage11";
import LaymanPage12 from "./LaymanPage12";
import LaymanPage13 from "./LaymanPage13";
import LaymanPage14 from "./LaymanPage14";
import LaymanPage15 from "./LaymanPage15";
import LaymanPage_aion from "./LaymanPage_aion";
import LaymanPage16 from "./LaymanPage16";
import LaymanPage16_radhakrishna_innocence from "./LaymanPage16_radhakrishna_innocence";
import LaymanPage17 from "./LaymanPage17";
import LaymanPage18 from "./LaymanPage18";
import LaymanPage18_yhvh from "./LaymanPage18_yhvh";
import LaymanPage18_elohim from "./LaymanPage18_elohim";
// import LaymanPage19 from "./LaymanPage19";
import LaymanPage20 from "./LaymanPage20";
import LaymanPage21 from "./LaymanPage21";
import LaymanPage22 from "./LaymanPage22";
import LaymanPage23 from "./LaymanPage23";
import LaymanPage_Zodiac_Planetary_Powers from "./LaymanPage_Zodiac_Planetary_Powers";
import LaymanPage24 from "./LaymanPage24";
import LaymanPage25 from "./LaymanPage25";
import LaymanPage26 from "./LaymanPage26";
import LaymanPage27 from "./LaymanPage27";
import LaymanPage28 from "./LaymanPage28";
import LaymanPage29 from "./LaymanPage29";
import LaymanPage30 from "./LaymanPage30";
import LaymanPage31 from "./LaymanPage31";
import LaymanPage33 from "./LaymanPage33";
import LaymanPage34 from "./LaymanPage34";
import LaymanPage32 from "./LaymanPage32";
import LaymanPage35 from "./LaymanPage35";
import LaymanPage36 from "./LaymanPage36";
import LaymanPage37 from "./LaymanPage37";
import LaymanPage38 from "./LaymanPage38";
import LaymanPage40 from "./LaymanPage40";
import LaymanPage39 from "./LaymanPage39";

const slidercopenents = [
  LaymanPage1,
  LaymanPage2,
  LaymanPage3,
  LaymanPage4,
  LaymanPage5,
  LaymanPage6,
  LaymanPage7,
  LaymanPage8,
  // LaymanPage9,
  // LaymanPage9_helios_part,
  // LaymanPage9_protogonos_part,
  LaymanPage9_sacred_divine,
  LaymanPage10,
  // LaymanPage10_kalikrishna,
  LaymanPage16_radhakrishna_innocence,
  LaymanPage14,
  LaymanPage16,
  LaymanPage11,
  LaymanPage13,
  LaymanPage15,
  LaymanPage_aion,
  // LaymanPage12,
  // LaymanPage13,
  // LaymanPage14,
  // LaymanPage15,
  // LaymanPage16,
  // LaymanPage16_radhakrishna_innocence,
  LaymanPage17,
  // LaymanPage18,
  // LaymanPage18_yhvh,
  // LaymanPage18_elohim,
  // LaymanPage19,
  LaymanPage20,
  LaymanPage21,
  // LaymanPage22,
  // LaymanPage23,
  LaymanPage_Zodiac_Planetary_Powers
  // LaymanPage24,
  // LaymanPage25,
  // LaymanPage26,
  // LaymanPage27,
  // LaymanPage28,
  // LaymanPage29,
  // LaymanPage30,
  // LaymanPage31,
  // LaymanPage32,
  // LaymanPage33,
  // LaymanPage34,
  // LaymanPage35,
  // LaymanPage36,
  // LaymanPage37,
  // LaymanPage38,
  // LaymanPage39,
  // LaymanPage40,
];

export default function LymanMainComps({ allComponentViewerState }) {
  const router = useRouter();
  const isInitialLoad = useRef(true);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (router.isReady) {
      const chapterFromUrl = parseInt(router.query.section, 10);
      if (
        !isNaN(chapterFromUrl) &&
        chapterFromUrl >= 0 &&
        chapterFromUrl < slidercopenents.length
      ) {
        setActiveIndex(chapterFromUrl);
      }
    }
  }, [router.isReady, router.query.section]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    const currentChapterInUrl = parseInt(router.query.section, 10) || 0;

    if (activeIndex !== currentChapterInUrl) {
      router.push(
        {
          pathname: "/layman-explanation",
          query: { section: activeIndex },
        },
        undefined,
        { shallow: true }
      );
    }
  }, [activeIndex]);

  const nextImage = () => {
    setActiveIndex((prevIndex) =>
      Math.min(prevIndex + 1, slidercopenents.length - 1)
    );
  };

  const prevImage = () => {
    setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <>
      <LymanCarouselComps
        allComponentViewerState={allComponentViewerState}
        activeIndex={activeIndex}
        slidercopenents={slidercopenents}
        onNext={nextImage}
        onPrevious={prevImage}
        totalChapters={slidercopenents.length}
        isInitialLoad={isInitialLoad}
      />
      <CentralDoctraineAndOtherCommonFooterBlock
        allComponentViewerState={allComponentViewerState}
        onNext={nextImage}
        onPrevious={prevImage}
        currentIndex={activeIndex}
        totalChapters={slidercopenents.length}
        buttonText={"section"}
      />
    </>
  );
}
